import { FeatureAttribute } from "../components/Attributes/FeatureAttributeField";
import { ConfigContainerChild } from "../types";

export const getTotalFromAttributes = (
  children: ConfigContainerChild[],
  attributes: FeatureAttribute[],
): number | string => {
  const total = children?.reduce((result, { attributeName }) => {
    const value = (attributes.find(({ name }) => name === attributeName)?.value as number) || 0;

    return result + value;
  }, 0);

  return typeof total === "number" ? total.toFixed(0) : "";
};
